import { render, staticRenderFns } from "./ANotification.vue?vue&type=template&id=448c9525&scoped=true&"
import script from "./ANotification.vue?vue&type=script&lang=js&"
export * from "./ANotification.vue?vue&type=script&lang=js&"
import style0 from "./ANotification.vue?vue&type=style&index=0&id=448c9525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c9525",
  null
  
)

export default component.exports